import { Controller } from "@hotwired/stimulus"
import { getComponent } from "./register_component.js"
import { createElement } from "react"
import { createRoot } from "react-dom/client"

export default class extends Controller {
  static targets = ["mount"]
  static values = {
    component: String,
    props: Object,
    mountOnConnect: { type: Boolean, default: true }
  }

  connect() {
    if (this.mountOnConnectValue) {
      this.mountComponent();
    }
  }

  disconnect() {
    this.unmountComponent();
  }

  mountElement() {
    return this.hasMountTarget ? this.mountTarget : this.element;
  }

  async mountComponent() {
    const entry = getComponent(this.componentValue);
    if (!entry) {
      console.error(`Component '${this.componentValue}' not found.`); /* eslint-disable-line no-console */
      return;
    }

    let Component;
    if (entry.kind === "sync") {
      Component = entry.component;
    } else {
      const mod = await entry.loader();
      if (!this.element.isConnected) return;
      Component = mod.default ?? mod[this.componentValue];
    }

    this.root = createRoot(this.mountElement());
    this.root.render(createElement(Component, Object.assign({}, this.propsValue)));
  }

  unmountComponent() {
    this.root?.unmount();
  }
}
